"use client";
import { jsx as r, jsxs as u } from "react/jsx-runtime";
import { forwardRef as B } from "react";
import { css as R, cx as x } from "@/styled-system/css";
import { useControllableState as h } from "../../hooks/use-controllable-state.js";
import { BannerIcon as v } from "./banner-icon.js";
import { BannerRootContext as C } from "./context/banner-root.context.js";
import { bannerRecipe as N } from "./styles/banner-root.styles.js";
const O = B(
  (n, t) => {
    const {
      tone: o = "info",
      children: s,
      className: a,
      css: c,
      isOpen: p,
      onClose: i,
      role: l = "status",
      ...m
    } = n, [e, f] = h({
      prop: p,
      defaultProp: !0
    });
    if (!e)
      return null;
    const d = R(N.raw({ tone: o }), c);
    return /* @__PURE__ */ r(
      C.Provider,
      {
        value: {
          tone: o,
          onClose: i,
          isOpen: e,
          closeBanner: () => {
            f(!1);
          }
        },
        children: /* @__PURE__ */ u(
          "div",
          {
            ref: t,
            "data-c11n-component": "Banner.Root",
            "data-c11n-version": "10.0.0-alpha.19",
            className: x("c11n", d, a),
            role: l,
            ...m,
            children: [
              /* @__PURE__ */ r(v, {}),
              s
            ]
          }
        )
      }
    );
  }
);
O.displayName = "Banner.Root";
export {
  O as BannerRoot
};
//# sourceMappingURL=banner-root.js.map
